// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY
import * as React from 'react';
import CustomerServiceTwoToneSvg from "@ant-design/icons-svg/es/asn/CustomerServiceTwoTone";
import AntdIcon from '../components/AntdIcon';

var CustomerServiceTwoTone = function CustomerServiceTwoTone(props, ref) {
  return React.createElement(AntdIcon, Object.assign({}, props, {
    ref: ref,
    icon: CustomerServiceTwoToneSvg
  }));
};

CustomerServiceTwoTone.displayName = 'CustomerServiceTwoTone';
export default React.forwardRef(CustomerServiceTwoTone);